import axios from "axios";
import { API_BASE_PATH } from "../../environment";
import { toast } from "react-toastify";

const LOGIN_API_URL = `${API_BASE_PATH}/auth/login`;

// ====== Error Extractor ======
const extractErrorMessage = (error: any) => {
  const detail = error?.response?.data?.detail;
  let details = error?.response?.data?.details;
  const message = error?.response?.data?.message;

  if (typeof details === "string") {
    details = details.replace(/^\d+\s*:\s*/, ""); // strip numeric codes
  }

  return detail || details || message;
};

export const loginUser = async (
  email: string,
  password: string,
  rememberMe: boolean
) => {
  try {
    const formData = new URLSearchParams();
    formData.append("username", email);
    formData.append("password", password);

    const response = await axios.post(
      `${LOGIN_API_URL}?remember_me=${rememberMe}`,
      formData,
      {
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }
    );

    toast.success("Login successful");
    return response.data;
  } catch (error: any) {
    let msg = extractErrorMessage(error);
    toast.error(msg);
    throw new Error(msg || "Login failed. Please try again.");
  }
};
